
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Onycomycosis(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Onycomycosis"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Onychomycosis is <b>a fungal infection of the toenails or fingernails</b> that may involve any component of the nail unit, including the matrix, bed, or plate. Onychomycosis can cause pain, discomfort, and disfigurement and may produce serious physical and occupational limitations, as well as reducing quality of life.
                                </p>
                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/onycomycosis/1.png")} alt="onycomycosis" />
                                    </div>
                                </div>
                                <br></br>
                                <p>
                                    <b>Symptoms</b>
                                </p>
                                <p>Usually self-diagnosable</p>
                                <p>The main symptoms are changes in the appearance of nails. Rarely, the condition causes pain or a slightly foul odour.</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Onychomycosis">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Onycomycosis;